import Flex from "@jewlr/storybook/core/flex"
import loadable from "@loadable/component"
import { useState, useCallback } from "react"

import Modal from "components/modal"
import { retry } from "helpers/application"

const Content = loadable(() => retry(() => import("./content")))

const Popup = () => {
  const [showContent, setShowContent] = useState(false)
  const afterShow = useCallback(() => {
    setShowContent(true)
  })
  return (
    <Modal
      afterShow={afterShow}
      contentStyle={{
        pb: { _: 7, desktop: 2 },
        pt: 0,
        px: { _: 2, desktop: 3 },
      }}
      headerType="basic"
      height="100%"
      show="#show-cart-item"
      width="600px"
    >
      <Flex data-cy="cart-atc-modal" flexDirection="column">
        {showContent && <Content />}
      </Flex>
    </Modal>
  )
}

export default Popup
